import { Checkbox, FormControl, ListItemText, MenuItem, Select, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

export interface FrequencyOption {
  id: number
  name: string
}

interface ServiceFrequencyFilterProps {
  options: FrequencyOption[]
  value: number[]
  onChange: (ids: number[]) => void
}

const ServiceFrequencyFilter = ({ options, value, onChange }: ServiceFrequencyFilterProps) => {
  const { t } = useTranslation(['calendar'])

  if (options.length === 0) return null

  const nameById = new Map(options.map(o => [o.id, o.name]))

  return (
    <FormControl size="small" sx={{ minWidth: 220, maxWidth: 320 }}>
      <Select
        multiple
        displayEmpty
        value={value}
        onChange={e => onChange(e.target.value as number[])}
        sx={{ borderRadius: 2, fontWeight: 600 }}
        renderValue={(selected: number[]) =>
          selected.length === 0 ? (
            <Typography component="span" sx={{ color: 'text.secondary', fontWeight: 500 }}>
              {t('all-frequencies', { ns: 'calendar' })}
            </Typography>
          ) : (
            selected
              .map(id => nameById.get(id))
              .filter(Boolean)
              .join(', ')
          )
        }
      >
        {options.map(option => (
          <MenuItem key={option.id} value={option.id}>
            <Checkbox checked={value.includes(option.id)} size="small" />
            <ListItemText primary={option.name} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default ServiceFrequencyFilter
